import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import Header from "../components/header/Header";
import Sidebar from "../components/sidebar/Sidebar";
import { UserContext } from "../context/UserContext";

const ProtectedRoute = ({
  component: Component,
  render,
  addHeader,
  addSidebar,
  ...rest
}) => {
  const { user } = useContext(UserContext);

  const redirecionar = (props) => {
    const toLogin = (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: props.location },
        }}
      />
    );

    if (user) {
      if (!user.accessRoutes) {
        return toLogin;
      }
      if (
        user.accessRoutes &&
        user.accessRoutes.split(",").indexOf(rest.path) === -1
      ) {
        return toLogin;
      }
      return Component ? (
        <>
          {addHeader && <Header />}
          {addSidebar && <Sidebar />}
          <div style={{ marginTop: 80 }}>
            <Component {...props} />
          </div>
        </>
      ) : (
        render(props)
      );
    } else {
      return toLogin;
    }
  };

  return <Route {...rest} render={(props) => redirecionar(props)} />;
};

export default ProtectedRoute;
